import { serviceDisclosureUrl } from './urls';
import { DisclosurePostData } from '../../model/disclosureData';
import { createAxios } from './apiClient';

export const getDisclosureData = (disclosureId: string) => {
  const instance = createAxios();
  return instance
    .get(serviceDisclosureUrl() + encodeURIComponent(disclosureId))
    .then(response => {
      return response.data.data;
    });
};

export const postDisclosure = (disclosureId: string, formdata: DisclosurePostData) => {
  const data: DisclosurePostData = {
    ...(formdata as DisclosurePostData),
  };

  const instance = createAxios();
  return instance.post(serviceDisclosureUrl() + encodeURIComponent(disclosureId), data);
};



// WEBPACK FOOTER //
// ./src/shared/api/DisclosureApi.tsx